'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var PieChart = React.createClass({
  render: function () {
    return (
      <div className="component-SimpleCom">
        <img width='100%' height='100%' src={assetsHelper.getComponentAsset('pieChart')} alt=""/>
      </div>
    )
  }
});

module.exports = PieChart;



// WEBPACK FOOTER //
// ./src/views/Components/PieChart.jsx